<app-service-exception-editor-with-save
  (onUploadComplete)="closeDialog($event)"
></app-service-exception-editor-with-save>
